export const margin = ({ theme, mt, ml, mr, mb, mx, my }) => `
  ${mt || my ? `margin-top: ${theme.spacing[mt] || mt || theme.spacing[my] || my};` : ''}
  ${ml || mx ? `margin-left: ${theme.spacing[ml] || ml || theme.spacing[mx] || mx};` : ''}
  ${mr || mx ? `margin-right: ${theme.spacing[mr] || mr || theme.spacing[mx] || mx};` : ''}
  ${mb || my ? `margin-bottom: ${theme.spacing[mb] || mb || theme.spacing[my] || my};` : ''}
`;

export const padding = ({ theme, pt, pl, pr, pb, px, py }) => `
  ${pt || py ? `padding-top: ${theme.spacing[pt] || pt || theme.spacing[py] || py};` : ''}
  ${pl || px ? `padding-left: ${theme.spacing[pl] || pl || theme.spacing[px] || px};` : ''}
  ${pr || px ? `padding-right: ${theme.spacing[pr] || pr || theme.spacing[px] || px};` : ''}
  ${pb || py ? `padding-bottom: ${theme.spacing[pb] || pb || theme.spacing[py] || py};` : ''}
`;

export const positioning = ({ position = 'relative', top, left, right, bottom, zIndex }) => `
  position: ${position};
  ${top ? `top: ${top};` : ''}
  ${left ? `left: ${left};` : ''}
  ${right ? `right: ${right};` : ''}
  ${bottom ? `bottom: ${bottom};` : ''}
  ${zIndex ? `z-index: ${zIndex};` : ''}
`;

export const spacing = (props) => `
  ${margin(props)}
  ${padding(props)}
`;
